/**
 * Telegram Web color palettes — dark and light themes
 * Used only by chat preview components via sx props
 */

import { DB_STATUS_COLORS } from '@/utils/dbStatus';

export interface TelegramTheme {
  sidebarBg: string;
  sidebarHeaderBg: string;
  sidebarItemHover: string;
  sidebarItemActive: string;
  sidebarText: string;
  sidebarTextMuted: string;
  sidebarBadgeBg: string;
  sidebarBadgeText: string;
  headerBg: string;
  headerText: string;
  chatBg: string;
  bubbleChannel: string;
  bubbleText: string;
  bubbleTimestamp: string;
  bubbleLink: string;
  searchBg: string;
  searchText: string;
  searchBorder: string;
  statusInDb: string;
  statusNotInDb: string;
  statusWeHaveMore: string;
  statusChannelMore: string;
}

export const TELEGRAM_DARK = {
  // Sidebar
  sidebarBg: '#17212b',
  sidebarHeaderBg: '#242f3d',
  sidebarItemHover: '#202b36',
  sidebarItemActive: '#2b5278',
  sidebarText: '#ffffff',
  sidebarTextMuted: '#8d9ba6',
  sidebarBadgeBg: '#4082bc',
  sidebarBadgeText: '#ffffff',

  // Header
  headerBg: '#517da2',
  headerText: '#ffffff',

  // Chat area
  chatBg: '#0e1621',
  bubbleChannel: '#2b5278',
  bubbleText: '#f5f5f5',
  bubbleTimestamp: '#6d8da2',
  bubbleLink: '#6ab2f2',

  // Search
  searchBg: '#242f3d',
  searchText: '#a0acb8',
  searchBorder: '#3a4654',

  // DB Status indicators — same swatches in both themes, defined once in
  // utils/dbStatus.ts because non-Telegram views (the Channels page) need them.
  statusInDb: DB_STATUS_COLORS.in_db,
  statusNotInDb: DB_STATUS_COLORS.not_in_db,
  statusWeHaveMore: DB_STATUS_COLORS.we_have_more,
  statusChannelMore: DB_STATUS_COLORS.channel_has_more,
} as const;

export const TELEGRAM_LIGHT = {
  // Sidebar
  sidebarBg: '#ffffff',
  sidebarHeaderBg: '#f0f2f5',
  sidebarItemHover: '#f0f2f5',
  sidebarItemActive: '#3390ec',
  sidebarText: '#000000',
  sidebarTextMuted: '#707579',
  sidebarBadgeBg: '#3390ec',
  sidebarBadgeText: '#ffffff',

  // Header
  headerBg: '#517da2',
  headerText: '#ffffff',

  // Chat area
  chatBg: '#e6ebee',
  bubbleChannel: '#eeffde',
  bubbleText: '#000000',
  bubbleTimestamp: '#6e9c6e',
  bubbleLink: '#3390ec',

  // Search
  searchBg: '#e6ebee',
  searchText: '#707579',
  searchBorder: '#dadce0',

  // DB Status indicators — same swatches in both themes, defined once in
  // utils/dbStatus.ts because non-Telegram views (the Channels page) need them.
  statusInDb: DB_STATUS_COLORS.in_db,
  statusNotInDb: DB_STATUS_COLORS.not_in_db,
  statusWeHaveMore: DB_STATUS_COLORS.we_have_more,
  statusChannelMore: DB_STATUS_COLORS.channel_has_more,
} as const;

/** @deprecated Use useChatTheme() hook instead */
export const TELEGRAM = TELEGRAM_DARK;
